import { Box } from '@hakimo-ui/hakimo/types';
import {
  getMediaContentRect,
  getPolygonLines,
  imageMarkerToClientMarker,
} from '@hakimo-ui/hakimo/ui-elements';
import { useVideoCurrentTime } from '@hakimo-ui/hakimo/util';
import { useEffect, useMemo, useRef } from 'react';
import { getVideoPolygons } from '../util';
interface Props {
  boxes?: Box[];
  videoRect?: DOMRect;
  videoWidth?: number;
  videoHeight?: number;
  videoRef?: React.RefObject<HTMLVideoElement>;
}
export function AlarmVideoBox(props: Props) {
  const { boxes = [], videoRect, videoHeight, videoWidth, videoRef } = props;
  const containerRef = useRef<HTMLDivElement>(null);
  const currentSecond = useVideoCurrentTime(videoRef);

  useEffect(() => {
    const video = videoRef?.current;
    let observer: MutationObserver;
    if (video) {
      observer = new MutationObserver(function (mutations) {
        mutations.forEach(function () {
          const videoTransform = video.style.transform;
          const videoTranslate = video.style.translate;
          if (containerRef.current) {
            const svg = containerRef.current.children[0] as SVGElement;
            svg.style.transform = videoTransform;
            svg.style.translate = videoTranslate;
          }
        });
      });
      observer.observe(video, {
        attributes: true,
        attributeFilter: ['style'],
      });
    }

    return () => {
      observer && observer.disconnect();
    };
  }, [videoRef]);

  const visibleBoxes = useMemo(() => {
    return boxes.filter(
      (box) => box.frame === -1 || box.frame === currentSecond
    );
  }, [boxes, currentSecond]);

  const boxesPolygon = useMemo(
    () => getVideoPolygons(visibleBoxes),
    [visibleBoxes]
  );
  const polygons = useMemo(() => {
    const video = videoRef?.current;
    if (!videoRect || !boxesPolygon || !video) {
      return [];
    }
    const contentRect = getMediaContentRect(video, videoRect);
    return boxesPolygon.map((polygon) => {
      return {
        ...polygon,
        points: polygon.points.map((marker) => {
          if (videoHeight && videoWidth && contentRect) {
            const [x, y] = imageMarkerToClientMarker(
              [contentRect.width, contentRect.height],
              [videoWidth, videoHeight],
              { point: marker }
            ).point;
            return [
              x + contentRect.offsetX,
              y + contentRect.offsetY,
            ] as typeof marker;
          }
          return marker;
        }),
      };
    });
  }, [videoRect, boxesPolygon, videoHeight, videoWidth, videoRef]);
  return <div ref={containerRef}>{getPolygonLines(polygons)}</div>;
}
export default AlarmVideoBox;
